"use client";

import * as TabsPrimitive from "@radix-ui/react-tabs";
import { ReactNode } from "react";
import TabsList from "./TabsList";

type Props = {
	defaultValue: string;
	TriggerComponent: ReactNode;
	ContentComponent: ReactNode;
};

/**
 * タブ コンポーネント
 * @param props props
 * @returns タブコンポーネント
 */
export default function Tabs(props: Props) {
	const { defaultValue, TriggerComponent, ContentComponent } = props;

	return (
		<TabsPrimitive.Root defaultValue={defaultValue}>
			<TabsList>{TriggerComponent}</TabsList>
			{ContentComponent}
		</TabsPrimitive.Root>
	);
}
